import { all, call, fork, put, setContext } from 'redux-saga/effects';
import { routinePromiseWatcherSaga } from 'redux-saga-routines';
import url from 'url';
import auth, { authWatcher } from './auth';
import { appStartBrowser } from '../actions/app';

const getUTMParams = () => {
  if (typeof window === 'undefined') {
    return {};
  }
  const { query } = url.parse(window.location.toString(), true);
  return Object.keys(query)
    .filter(key => key.match(/^utm_/i))
    .reduce((result, key) => ({ ...result, [key]: query[key] }), {});
};

function* appStart() {
  if (typeof window === 'undefined') {
    return;
  }

  yield put(appStartBrowser());
}

export default function* root() {
  yield call(auth);

  yield setContext({
    utmParams: getUTMParams()
  });

  yield all([fork(authWatcher), fork(routinePromiseWatcherSaga), fork(appStart)]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js